import { useNavigate, useParams } from "react-router-dom";
import BaseContainerWrapper from "../../common/components/BaseContainerWrapper";
import useComponents from "../../common/hooks/pages/useComponents";
import ComponentForm from "../components/ComponentForm";
import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import { useEffect } from "react";

function ComponentFormContainer() {
  const navigate = useNavigate();

  const { id } = useParams();

  const { createComponent, getComponent, deleteComponent } = useComponents();

  const { toast } = usePopup();

  const { mutate: createComponentMutate, isLoading: isCreating } = useMutation({
    mutationFn: createComponent,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/components");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
      toast(message, "error");
    },
  });

  const {
    data,
    mutate: getComponentMutate,
    isLoading: isGetting,
  } = useMutation({
    mutationFn: getComponent,

    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting component!";
      toast(message, "error");
    },
  });

  const { componentId, mutate: deleteComponentMutate } = useMutation({
    mutationFn: deleteComponent,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/components");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while deleting component!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    if (id) {
      getComponentMutate(id);
    }
  }, []);

  const deleteHandler = (id) => {
    deleteComponentMutate(id);
  };

  const { component } = data?.data || {};
  return (
    <BaseContainerWrapper>
      <ComponentForm
        onSubmit={(data) => createComponentMutate(data)}
        isSubmitting={isCreating}
        component={component}
        id={id}
        onDeleteComponent={deleteHandler}
      />
    </BaseContainerWrapper>
  );
}

export default ComponentFormContainer;
